var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-80",
            staticStyle: { "overflow-y": "auto" },
            style: { maxHeight: _vm.getMaxHeightClient() + "px" },
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "modal-body m-0" },
              [
                _c("devis-form", {
                  attrs: {
                    contactSearch: "",
                    invoiceType: _vm.devisFormData.invoiceType,
                    buyer: _vm.devisFormData.buyer,
                    propsDateExec: _vm.devisFormData.dateExec,
                    propsSellerIBAN: _vm.devisFormData.sellerIBAN,
                    propsInvoiceRef: _vm.devisFormData.invoiceRef,
                    propsProducts: _vm.devisFormData.products,
                    amountHT: _vm.devisFormData.amountHT,
                    amountTaxes: _vm.devisFormData.amountTaxes,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }